{
    "keys": {
        "common": {
            "action_timestamp": "Date de l'action",
            "organization_legal_name": "Nom de l'organisation",
            "action_type": "Type d'action",
            "user_email": "Réalisé par",
            "outcome": "Résultat",
            "before": "Valeur initiale",
            "after": "Valeur finale"
        },
        "pos_terminals": {
            "serial_number": "Numéro de série",
            "manufacturer": "Constructeur",
            "label": "Libellé TPE",
            "custom_label": "Libellé TPE 2"
        },
        "sim_cards": {
            "iccid": "Numéro de SIM"
        },
        "users": {
            "email": "Utilisateurs",
            "type": "Type"
        }
    },
    "filter": {
        "placeholder": {
            "common": {
                "organization_legal_name": "Filtrer par nom de l'organisation",
                "user_email": "Filtrer par email"
            },
            "pos_terminals": {
                "serial_number": "Filtrer par numéro de série",
                "manufacturer": "Filtrer par constructeur",
                "label": "Filtrer par libellé TPE",
                "custom_label": "Filtrer par libellé TPE 2"
            },
            "sim_cards": {
                "iccid": "Filtrer par numéro de SIM"
            },
            "users": {
                "email": "Filtrer par utilisateurs"
            }
        }
    },
    "status": {
        "outcome": {
            "success": "Succès",
            "failure": "Échec"
        }
    },
    "actions": {
        "pos_terminals": {
            "IP_SUBSCRIPTION_ACTIVATION": "Activation abonnement IP",
            "IP_SUBSCRIPTION_MULTIPLE_ACTIVATION": "Activation multiple TPE",
            "REWAREHOUSE": "Remise en stock",
            "BLACKLIST_ADD": "Blocage TPE",
            "BLACKLIST_ADD_MULTIPLE": "Blocage multiple TPE",
            "MIGRATE": "Migration",
            "IP_SUBSCRIPTION_TERMINATE": "Résiliation abonnement IP",
            "BLACKLIST_REMOVE": "Autorisation TPE",
            "LABEL_UPDATE": "Modification libellé TPE",
            "BLACKLIST_ADD_TEMPORARY": "Autorisation Temporaire TPE",
            "DISSOCIATE_SIM": "Dissociation carte SIM",
            "ASSOCIATE_SIM": "Association carte SIM",
            "UPDATE_IP_OFFER": "Modification de l'offre IP",
            "PAYLUDD_SUBSCRIPTION_TERMINATE": "Résiliation Payludd"
        },
        "sim_cards": {
            "UPDATE_SIM_LABEL": "Modification de libellé",
            "UPDATE_SIM_OFFER": "Modification de forfait",
            "ACTIVATE_SIM": "Activation carte",
            "REACTIVATE_SIM": "Réactivation carte",
            "SUSPEND_SIM": "Suspension carte",
            "TERMINATE_SIM": "Résiliation carte",
            "DISSOCIATE_POS_TERMINAL": "Dissociation TPE",
            "ASSOCIATE_POS_TERMINAL": "Association TPE",
            "ASK_REPLACE_SIM": "Demande de remplt.",
            "SIM_REPLACE": "Remplacement SIM"
        },
        "users": {
            "MANAGEMENT_USER_CREATION": "Ajout utilisateur monétique",
            "MERCHANT_USER_CREATION": "Ajout utilisateur marchand",
            "USER_LOGIN_AS": "Se connecter en tant que",
            "USER_PERMISSIONS": "Modification permission utilisateur",
            "USER_ACTIVATION": "Activation utilisateur",
            "USER_DEACTIVATION": "Désactivation utilisateur",
            "USER_REMOVAL": "Suppression utilisateur",
            "USER_EMAIL_ACTIVATION_RESENDING": "Renvoi de mail utilisateur"
        },
        "row": {
            "details": "Détails"
        }
    },
    "tooltip": {
        "user_initiator": "{{userInitiator}} connecté en tant que {{userAccountUpdated}}"
    },
    "cells": {
        "modification_count_one": "{{count}} modification",
        "modification_count_other": "{{count}} modifications",
        "no_user": "Inconnu",
        "no_permission_modified": "Aucune permission modifiée"
    },
    "users": {
        "MANAGEMENT": "Utilisateur monétique",
        "MERCHANT": "Utilisateur marchand"
    },
    "modal": {
        "details": {
            "title": "Détails de l'historique",
            "action": "Action : ",
            "initial": "Valeur initiale :",
            "final": "Valeur finale :",
            "no_value": "Pas de valeur"
        }
    }
}